module.exports = __webpack_public_path__ + "assets/novanaut.4d0a3194f203285a8b9be957f3aa624c.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/novanaut.svg
// module id = 436
// module chunks = 0